module.exports = __webpack_public_path__ + "static/media/jamsHoneySpreads.f4078d48.webp";